var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2401_72648)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.90897C4.2129 1.90897 1.14286 4.97902 1.14286 8.76611C1.14286 12.5532 4.2129 15.6233 8 15.6233C11.7871 15.6233 14.8571 12.5532 14.8571 8.76611C14.8571 4.97902 11.7871 1.90897 8 1.90897ZM0 8.76611C0 4.34784 3.58172 0.766113 8 0.766113C12.4183 0.766113 16 4.34784 16 8.76611C16 13.1844 12.4183 16.7661 8 16.7661C3.58172 16.7661 0 13.1844 0 8.76611Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.19468C8.31559 8.19468 8.57143 8.45052 8.57143 8.76611V12.7661C8.57143 13.0817 8.31559 13.3375 8 13.3375C7.68441 13.3375 7.42857 13.0817 7.42857 12.7661V8.76611C7.42857 8.45052 7.68441 8.19468 8 8.19468Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85714 5.90897C6.85714 5.27779 7.36882 4.76611 8 4.76611C8.63118 4.76611 9.14286 5.27779 9.14286 5.90897C9.14286 6.54015 8.63118 7.05183 8 7.05183C7.36882 7.05183 6.85714 6.54015 6.85714 5.90897Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2401_72648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.766113)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c2fe055b9aa363fedd52314628bb5976.svg";
export { ForwardRef as ReactComponent };